// Sets null as the value for any key containing a falsy value
// eslint-disable-next-line import/prefer-default-export
export function nullifyFalsyKeys(obj) {
  const result = {};
  Object.keys(obj).forEach(key => {
    result[key] = obj[key] ? obj[key] : null;
  });
  return result;
}
